import { render } from "./ManageGroupingModal.vue?vue&type=template&id=6296140e"
import script from "./ManageGroupingModal.vue?vue&type=script&lang=js"
export * from "./ManageGroupingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__